import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { ToolsService } from 'src/app/recursos/tools.service';
import { IngresoService } from 'src/app/servicios/ingreso.service';
import { LoaderComponent } from 'src/app/servicios/loader/loader.component';
import { SeleccionService } from 'src/app/servicios/seleccion.service';

@Component({
  selector: 'app-ficha-custionarios',
  templateUrl: './ficha-custionarios.component.html',
  styleUrls: ['./ficha-custionarios.component.css']
})
export class FichaCustionariosComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtOptionsGrupo: DataTables.Settings = {};
  public dtTriggerGrupo: Subject<any>;

  public encabezado: string = ""; public nombreBeca: string = ""; public tituloModal: string = ''; opGestion: number = 0;
  public vecAddEncuesta = []; public vecVerEncuestas = [];

  constructor(private modalService: NgbModal, private alerti: AlertifyService, private srvInsert: IngresoService, private cargando: LoaderComponent,
    private srvSelect: SeleccionService, private tools: ToolsService, private ruta: Router) { }

  ngOnInit() {
    this.dtTriggerGrupo = new Subject<any>();
    this.dtOptionsGrupo[0] = this.tools.OpcionesTabla(10);
    this.verCuestionarios();
    this.encabezado = "Ficha del estudiante";
    this.nombreBeca = localStorage.getItem('modNom');
    this.instanciaVariables(0, '', '', '', '', 0, 2, 0, false);
  }
  //ABRIR EL MODAL QUE PERMITE AGREGAR UN GRUPO DE PREGUNTAS
  verModGrupo(nombModal) {
    if (localStorage.getItem('insUser') == 'true') {
      this.tituloModal = 'Registrar una nueva encuesta';
      this.opGestion = 6;
      this.instanciaVariables(0, '', '', '', '', 0, 2, 0, false);
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //ABRIR EL MODAL QUE PERMITE AGREGAR UN GRUPO DE PREGUNTAS
  verModEditaGrupo(nombModal, objFicha) {
    if (localStorage.getItem('modUser') == 'true') {
      this.tituloModal = 'Registrar una nueva encuesta';
      this.opGestion = 6;
      this.instanciaVariables(objFicha.intIdEncuesta, objFicha.strNombre, objFicha.strDescripcion, objFicha.strRecomendacion, objFicha.strTerminos,
        objFicha.fltTiempo, objFicha.intEstado, objFicha.intVisible, objFicha.intEstado == 1 ? true : false);
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //CONFIRMACION SI ES DEFINITIVO EL CAMBIO EN EL CUESTIONARIO
  confirmacionRegCuestionario() {
    if (this.vecAddEncuesta[0].estado == 1) {
      this.alerti.confirm('El cuestionario lo va a registrar como definitivo, después de esta acción no se puede realizar ningún cambio.. Está seguro de continuar?', () => {
        this.ingresoCuestionario();
      });
    }
    else
      this.ingresoCuestionario();
  }
  //REGISTRAR UN NUEVO CUESTIONARIO / FICHA
  ingresoCuestionario() {
    this.srvInsert.registroGestionFicha(this.vecAddEncuesta[0].encuesta, this.vecAddEncuesta[0].nombre, this.vecAddEncuesta[0].detalle, this.vecAddEncuesta[0].recomendacion,
      this.vecAddEncuesta[0].termino, this.vecAddEncuesta[0].tiempo, this.vecAddEncuesta[0].visible, this.vecAddEncuesta[0].estado, 'na', 'na', 'na', 'na', 'na', 'na', localStorage.getItem('idPersona'), 1).subscribe(res => {
        if (res.respFicha) {
          this.alerti.success('Datos registrados correctamente');
          this.verCuestionarios();
          this.cerrarModal();
        }
        else
          this.alerti.error('Error inesperado vuelva a intentar más tarde');
      });
  }

  //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS REGISTRADOS
  async verCuestionarios() {
    var table2 = $('#tblGrupo').DataTable({
      destroy: true
    });
    table2.destroy();
    this.cargando.abrir();
    this.vecVerEncuestas = [];
    const resFicha = await new Promise<any>(resolve =>
      this.srvSelect.obtenerGestionFichaEstudiante(1, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resFicha.resultado) {
      this.vecVerEncuestas = resFicha.fichaEstudiantil;
      this.dtTriggerGrupo.next();
    }
    else
      this.alerti.message('No se encntró información de encuestas registradas');
    this.cargando.cerrar();
    console.log(this.vecVerEncuestas)
  }
  //IR A LA PAGINA DE LAS PREGUNTAS QUE CORRESPONDE A LA ENCUESTA SELECCIOANDA
  verPreguntasFicha(objFicha) {
    localStorage.setItem('localNumEnc', objFicha.intIdEncuesta);
    this.ruta.navigate(["/gestion/fichaPreguntas25"]);
  }

  //INSTANCIAR VARIABLES
  instanciaVariables(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9) {
    this.vecAddEncuesta = [];
    this.vecAddEncuesta.push({ encuesta: dato1, nombre: dato2, detalle: dato3, recomendacion: dato4, termino: dato5, tiempo: dato6, estado: dato7, visible: dato8, edita: dato9 });
  }
  cerrarModal() {
    this.mr.close();
  }
}
